import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "iframe"]

  connect() {
    console.log("Vimeo controller connected") 
    this.boundHandleGlobalClick = this.handleGlobalClick.bind(this)
    this.boundHandleKeydown = this.handleKeydown.bind(this)

    document.addEventListener("click", this.boundHandleGlobalClick)
    document.addEventListener("keydown", this.boundHandleKeydown)
  }

  disconnect() {
    document.removeEventListener("click", this.boundHandleGlobalClick)
    document.removeEventListener("keydown", this.boundHandleKeydown)
  }

  handleGlobalClick(event) {
    const button = event.target.closest("[data-vimeo-launch-url]")
    if (!button) return

    const url = button.dataset.vimeoLaunchUrl
    if (!url) { 
      return
    }

    this.iframeTarget.src = url
    this.overlayTarget.classList.remove("hidden")
  }

  handleKeydown(event) {
    if (event.key === "Escape" && !this.overlayTarget.classList.contains("hidden")) {
      this.close()
    }
  }

  close() { 
    this.overlayTarget.classList.add("hidden")
    this.iframeTarget.src = ""
  }
}
